import React from 'react';
import Slider from 'react-slick';

import type { Reference } from '@swf/generated/cms/types';

import styles from './CMSRotator.scss';
import CMSRotatorItem from './CMSRotatorItem/CMSRotatorItem';

interface Props {
  items: Reference[];
}

const CMSRotator: React.FC<Props> = ({ items }) => (
  <div className={styles.cmsRotator}>
    <Slider
      dots
      infinite
      speed={500}
      slidesToShow={1}
      slidesToScroll={1}
      arrows={false}
      autoplay
      autoplaySpeed={5000}
      pauseOnDotsHover
      pauseOnHover={false}
    >
      {items.map((item, key) => (
        <CMSRotatorItem item={item} key={key} />
      ))}
    </Slider>
  </div>
);

export default CMSRotator;
